'use client';

import { useFeatureFlag } from '@/@feature-flags/hooks';
import type { FeatureGateProps } from '@/@feature-flags/types/props';
import type { ReactElement } from 'react';

/**
 * Conditionally renders children based on a feature flag's access state.
 * Renders `fallback` (defaults to `null`) when the flag is disabled.
 */
export function FeatureGate({
    flag,
    fallback = null,
    children,
}: FeatureGateProps): ReactElement | null {
    const isEnabled = useFeatureFlag(flag);

    if (!isEnabled) {
        return fallback as ReactElement | null;
    }

    return children as ReactElement;
}
